import { parse, stringify } from 'qs';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { getEncodePath, getHomeFolderPath } from 'reactApp/utils/urlHelper';

export const getRouterLinkUrl = (id: string, storage: EStorageType, href: string | null = null, search = '') => {
    const { isHome, isAttaches } = getStorage(storage);

    if (isHome) {
        return getEncodePath(getHomeFolderPath(id));
    }

    if (isAttaches && search && href) {
        const { folderId, ...rest } = parse(search, { ignoreQueryPrefix: true });
        return `${href}&${stringify(rest)}`;
    }

    return isAttaches ? (href || id) : getEncodePath(href || id);
};
